// Practical implemntation of RFC 2822. Omits double quotes and square brackets
const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

export const validateEmail = (email: string = '') => !!email.match(emailRegex);
export const validateEmptyOrEmail = (email: string = '') => !email || validateEmail(email);
export const validateNotEmpty = (value: any) => !!value;
